import { init as initThemeSwitcher } from "@/ThemeSwitcher";

// This entry point will be executed from the document head as soon as possible.
// Use this to apply styles before the page finishes loading.

initThemeSwitcher();
